export const extractNumbersInName = (str) => {
    const match = str.match(/^(\d+)(?:\s(\d+))?/);
    if (!match)
        return '';
    const rawNumber = match.slice(1).filter(Boolean).join('');
    const formatted = new Intl.NumberFormat('ru-RU').format(Number(rawNumber));
    return formatted;
};
